import React, { useContext, useState, useEffect } from 'react';
import { Redirect, useLocation } from 'react-router-dom';
import StoreContext from '../../Store/context';
import LicenseExpiredModal from '../../UI/Modal/LicenseExpiredModal';
import PlanUpgradeModal from '../../UI/Modal/PlanUpgradeModal';
import FriendlyTrialExpiredModal from '../../UI/Subscription/FriendlyTrialExpiredModal';
import SubscriptionCheckoutModal from '../../UI/Subscription/SubscriptionCheckoutModal';

const LICENSE_MODAL_DISMISSED_KEY = 'duzz_license_modal_dismissed_token';

// eslint-disable-next-line
const PrivateComponents = ({ children }) => {
  const { credencials, modalUpgradePlan, setModalUpgradePlan } = useContext(StoreContext);
  const location = useLocation();
  const [showModal, setShowModal] = useState(false);
  const [showCheckoutModal, setShowCheckoutModal] = useState(false);

  const params = new URLSearchParams(location.search);
  const hasLoginToken = Boolean(params.get('loginToken'));

  const isTrial =
    credencials?.companyData?.is_trial === true ||
    credencials?.companyData?.status === 'trial' ||
    credencials?.companyData?.trial_used === true ||
    credencials?.is_trial === true;

  // Verify if license/trial is truly expired
  const endTimeStr = credencials?.companyData?.endTime || credencials?.licenseEndTime;
  let isTrulyExpired = Boolean(credencials?.isLicenseExpired);
  if (endTimeStr) {
    try {
      const endDt = new Date(endTimeStr.replace(' ', 'T'));
      const nowDt = new Date();
      if (endDt > nowDt) {
        isTrulyExpired = false;
      }
    } catch (e) { }
  }

  useEffect(() => {
    if (credencials && isTrulyExpired) {
      const dismissedToken = sessionStorage.getItem(LICENSE_MODAL_DISMISSED_KEY);
      // Show modal if: no token saved OR saved token is different from current session
      if (!dismissedToken || dismissedToken !== credencials.sessionToken) {
        setShowModal(true);
      }
    } else {
      setShowModal(false);
    }
  }, [credencials, isTrulyExpired]);

  const handleCloseLicenseModal = () => {
    setShowModal(false);
    // Mark as dismissed for this specific session token
    if (credencials?.sessionToken) {
      sessionStorage.setItem(LICENSE_MODAL_DISMISSED_KEY, credencials.sessionToken);
    }
  };

  const handleOpenCheckout = () => {
    setShowCheckoutModal(true);
  };

  if (location.pathname === '/onboarding' || location.pathname === '/') {
    return null;
  }

  if (hasLoginToken) {
    return <Redirect to={`/${location.search}`} />;
  }

  if (!credencials) {
    return <Redirect to="/" />;
  }

  return (
    <>
      {children}

      {/* Trial expired friendly modal */}
      {isTrial ? (
        <FriendlyTrialExpiredModal
          open={showModal}
          onClose={handleCloseLicenseModal}
          onOpenCheckout={handleOpenCheckout}
        />
      ) : (
        <LicenseExpiredModal
          open={showModal}
          onClose={handleCloseLicenseModal}
          licenseEndTime={credencials.licenseEndTime}
        />
      )}

      <SubscriptionCheckoutModal
        open={showCheckoutModal}
        onClose={() => setShowCheckoutModal(false)}
      />

      <PlanUpgradeModal
        open={modalUpgradePlan}
        onClose={() => setModalUpgradePlan(false)}
      />
    </>
  );
};

export default PrivateComponents;

